import React from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// Import Context Providers
import { DashboardProvider } from './contexts/DashboardContext';
import { AuthProvider } from './contexts/AuthContext';
import { DraftsProvider } from './contexts/DraftsContext';
import { OrdersProvider } from './contexts/OrdersContext';
import { StoreProvider } from './contexts/StoreContext';
import { TemplateProvider } from './contexts/TemplateContext';
import { TourProvider } from './contexts/TourContext';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Cookie consent banner
import CookieConsentBanner from './Components/Common/CookieConsentBanner';

// [KAYIT-HATA] (Baris, 17 Eki 2026) TEK genel bildirim kutusu: her sayfanin toast.* cagrisi burada gorunur. Sayfalar kendi
// bildirim kutusunu KOYMAZ (react-toastify 10: containerId'siz toast her kutuda gosterilir -> cift bildirim). Kapi:
// src/utils/marketplaces.test.ts "tek genel bildirim kutusu".
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  return (
    <React.Fragment>
      <AuthProvider>
        <StoreProvider>
          <TourProvider>
            <TemplateProvider>
              <DashboardProvider>
                <OrdersProvider>
                  <DraftsProvider>
                    <Route />
                    <CookieConsentBanner />
                    <ToastContainer position="top-right" autoClose={5000} limit={3} newestOnTop closeOnClick pauseOnFocusLoss />

                  </DraftsProvider>
                </OrdersProvider>
              </DashboardProvider>
            </TemplateProvider>
          </TourProvider>
        </StoreProvider>
      </AuthProvider>
    </React.Fragment>
  );
}

export default App;
